import { Button, Card, DatePicker, Form, Icon, Input, InputNumber, message, Popconfirm, Select, Spin, Table } from 'antd';
import React from "react";
import { sanitizeFieldName } from "../../util/methods";
import moment from "moment";
import AssetModal from "../../components/AssetModal";
import SubAssetModal from "../../components/SubAssetModal";
import DocumentList from "../../components/DocumentList";
import Descriptions from "antd/lib/descriptions";
import MasterModal from "../../components/MasterModal";
import InlineCreateMasterModal from "../../components/InlineCreateMasterModal";
import FieldSearchForm from "../../components/FieldSearchForm";
import AccessControl from "../../components/AccessControl";

let parentPresent = [], parentAssetCode = [];

class Create extends React.Component {
    constructor() {
        super();
        this.addAsset = this.addAsset.bind(this);
        this.addSpareParts = this.addSpareParts.bind(this);
        this.id = 0;
        this.spareId = 0;
        this.state = {
            documentData: [],
            keys: [],
            intervalKeys: {},
            parentIntervalKeys: {},
            spareKeys: [],
            type: '',
            purchaseOrderData: {
                assets: [],
                spareParts: [],
                dependentAssets: [],
            },
            subAssets: {},
            parentAsset: [],
            parentPresent: [],
            parentAssetCode: [],
            parentOwner: [],
            dependentAssetKeys: {},
            openModal: false,
            purchaseOrderID: "",
            createdVendors: [],
            createdOwners: [],
        };
    }


    componentDidMount() {
        const { match, fetch } = this.props;
        if (match.params && match.params.id) {
            fetch(match.params.id);
            this.setState({
                purchaseOrderID: match.params.id,
            });
        }
        const data = [];
        const sdata = [];
        this.setState({
            keys: data,
            spareKeys: sdata
        });
    }

    componentWillUnmount() {
        parentPresent = [];
        parentAssetCode = [];
        this.props.unmountPurchaseOrder();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data && nextProps.data.assets && JSON.stringify(nextProps.data.assets) !== JSON.stringify(this.props.data.assets)) {
            const newArr = [];
            const { purchaseOrderData, keys } = this.state;
            nextProps.data.assets.map((item, idx) => {
                const { intervalKeys, parentIntervalKeys, dependentAssetKeys } = this.state;
                keys.push(`assets${idx}`);
                purchaseOrderData.assets.push({
                    index: idx,
                    data: {
                        equipmentSubType: item.asset.equipmentSubType,
                        altName: item.asset.altName,
                        description: item.asset.description,
                        owner: item.asset.owner,
                        parent: item.asset.parent,
                        documents: item.asset.documents,
                        assetId: item.asset._id,
                        assetCode: item.asset.assetCode,
                        assetModel: item.asset.assetModel,
                    }
                });

                if (item && item.dependentAsset && item.dependentAsset.length) {
                    for (let i = 0; i < item.dependentAsset.length; i++) {
                        let dAsset = item.dependentAsset[i];
                        purchaseOrderData.dependentAssets.push({
                            index: idx,
                            innerIndex: i,
                            data: {
                                equipmentSubType: dAsset.equipmentSubType,
                                altName: dAsset.altName,
                                description: dAsset.description,
                                owner: dAsset.owner,
                                parent: item.asset._id,
                                documents: item.asset.documents,
                                assetId: dAsset._id,
                                assetCode: dAsset.assetCode,
                                assetModel: dAsset.assetModel,
                            }
                        });
                    }
                }

                item.service && item.service.length && item.service.map((itm, index) => {
                    if (intervalKeys[`${idx}`]) {
                        intervalKeys[`${idx}`].keys.push(`interval${++intervalKeys[`${idx}`].id}`);
                    } else {
                        intervalKeys[`${idx}`] = {
                            id: 0,
                            keys: ['interval0'],
                        }
                    }
                });

                item.dependentAsset && item.dependentAsset.length && item.dependentAsset.map((itm, index) => {
                    if (dependentAssetKeys[`${idx}`]) {
                        dependentAssetKeys[`${idx}`].keys.push(`dependentAsset${++dependentAssetKeys[`${idx}`].id}`);
                    } else {
                        dependentAssetKeys[`${idx}`] = {
                            id: 0,
                            keys: ['dAsset0'],
                        }
                    }
                });


                item.parentService && item.parentService.length && item.parentService.map((itm, index) => {
                    if (parentIntervalKeys[`${idx}`]) {
                        parentIntervalKeys[`${idx}`].keys.push(`parentInterval${++parentIntervalKeys[`${idx}`].id}`);
                    } else {
                        parentIntervalKeys[`${idx}`] = {
                            id: 0,
                            keys: ['parentInterval0'],
                        }
                    }
                });
                this.setState({ intervalKeys, parentIntervalKeys, dependentAssetKeys, type: nextProps.data.type });
                item.asset && newArr.push(item.asset._id);
            });
            this.setState({
                keys,
                purchaseOrderData,
                documentData: nextProps.data.documents,
            });
        }
        if (nextProps.data && nextProps.data.spareParts && JSON.stringify(nextProps.data.spareParts) !== JSON.stringify(this.props.data.spareParts)) {
            this.setState({ type: nextProps.data.type, documentData: nextProps.data.documents });
            this.props.getAllUOM();
        }
    }

    saveOwner = (index, data) => {
        let owner = this.state.parentOwner;
        owner[index] = data;
        this.setState({ parentOwner: owner });
    }

    removeAsset = index => {
        const { keys } = this.state;
        const { form, filters } = this.props;
        const item = filters['assets'];
        if (keys.length === 1) {
            return;
        }
        const val = form.getFieldValue('assets');
        val.splice(index, 1);
        keys.splice(index, 1);
        for (let i = 0; i < val.length; i++) {
            Object.keys(item.schema).map((itm, index) => {
                form.setFieldsValue({
                    [`assets[${i}]['${itm}']`]: val[i][itm],
                });
            });
        }
        // Keep sub assets aligned with the shifted asset row indices.
        const { subAssets } = this.state;
        const newSubAssets = {};
        Object.keys(subAssets).forEach((k) => {
            const ki = Number(k);
            if (ki < index) {
                newSubAssets[ki] = subAssets[ki];
            } else if (ki > index) {
                newSubAssets[ki - 1] = subAssets[ki];
            }
        });
        this.setState({
            keys: keys,
            subAssets: newSubAssets,
        });
    };

    addAsset = () => {
        const { keys } = this.state;
        keys.push(`${'assets'}${this.id++}`);
        this.setState({
            keys: keys,
        });
    };

    setSubAssets = (index, list) => {
        const { subAssets } = this.state;
        this.setState({ subAssets: { ...subAssets, [index]: list } });
    };

    removeSpareParts = index => {
        const { spareKeys } = this.state;
        const { form, filters } = this.props;
        const item = filters['spareParts'];
        if (spareKeys.length === 1) {
            return;
        }

        const val = form.getFieldValue('spareParts');
        val.splice(index, 1);
        spareKeys.splice(index, 1);

        for (let i = 0; i < val.length; i++) {
            Object.keys(item.schema).map((itm, index) => {
                form.setFieldsValue({
                    [`spareParts[${i}]['${itm}']`]: val[i][itm],
                });
            });
        }

        this.setState({
            spareKeys: spareKeys,
        });
    };

    addSpareParts = () => {
        const { spareKeys } = this.state;
        spareKeys.push(`${'spareParts'}${this.spareId++}`);
        this.setState({
            spareKeys: spareKeys,
        });
    };

    removeInterval = (index, idx) => {
        const { intervalKeys } = this.state;
        const { form, filters } = this.props;
        const item = filters['assets']['schema']['service'];
        const val = form.getFieldValue('assets')[`${index}`]['service'];
        val.splice(idx, 1);
        intervalKeys[`${index}`].keys.splice(idx, 1);
        for (let i = 0; i < val.length; i++) {
            Object.keys(item.schema).map((itm, kk) => {
                form.setFieldsValue({
                    [`assets[${index}]['service'][${i}]['${itm}']`]: val[i][`${itm}`],
                });
            });
        }

        this.setState({ intervalKeys });
    };

    removeParentInterval = (index, idxx) => {
        const { parentIntervalKeys } = this.state;
        const { form, filters } = this.props;
        const item = filters['assets']['schema']['service'];
        const val = form.getFieldValue('assets')[`${index}`]['parentService'];
        val.splice(idxx, 1);
        parentIntervalKeys[`${index}`].keys.splice(idxx, 1);
        for (let i = 0; i < val.length; i++) {
            Object.keys(item.schema).map((itm, kk) => {
                form.setFieldsValue({
                    [`assets[${index}]['parentService'][${i}]['${itm}']`]: val[i][`${itm}`],
                });
            });
        }
        this.setState({ parentIntervalKeys });
    };


    removeDependentAsset = (index, idxx) => {
        const { dependentAssetKeys, purchaseOrderData } = this.state;
        const { form, filters } = this.props;
        const { assets, spareParts } = purchaseOrderData;
        const item = filters['assets']['schema']['dependentAsset'];
        const val = form.getFieldValue('assets')[`${index}`]['dependentAsset'];
        val.splice(idxx, 1);
        dependentAssetKeys[`${index}`].keys.splice(idxx, 1);
        for (let i = 0; i < val.length; i++) {
            item && item.schema && Object.keys(item.schema).map((itm, kk) => {
                form.setFieldsValue({
                    [`assets[${index}]['dependentAsset'][${i}]['${itm}']`]: val[i][`${itm}`],
                });
            });
        }
        let dArray = [];
        for (let i = 0; i < purchaseOrderData.dependentAssets.length; i++) {
            let dAsset = purchaseOrderData.dependentAssets[i];
            if (dAsset.innerIndex === idxx && dAsset.index === index) {
            } else {
                dArray.push(dAsset);
            }
        }
        this.setState({
            dependentAssetKeys, purchaseOrderData: {
                assets: assets,
                spareParts: spareParts,
                dependentAssets: dArray,
            }
        });
    };

    addParentInterval = (idxx) => {
        const { parentIntervalKeys } = this.state;
        if (parentIntervalKeys[`${idxx}`]) {
            parentIntervalKeys[`${idxx}`].keys.push(`parentInterval${++parentIntervalKeys[`${idxx}`].id}`);
        } else {
            parentIntervalKeys[`${idxx}`] = {
                id: 0,
                keys: ['parentInterval0'],
            }
        }
        this.setState({ parentIntervalKeys });
    };

    addInterval = (idx) => {
        const { intervalKeys } = this.state;
        if (intervalKeys[`${idx}`]) {
            intervalKeys[`${idx}`].keys.push(`interval${++intervalKeys[`${idx}`].id}`);
        } else {
            intervalKeys[`${idx}`] = {
                id: 0,
                keys: ['interval0'],
            }
        }
        this.setState({ intervalKeys });
    };

    addDependentAsset = (idx) => {
        const { dependentAssetKeys } = this.state;
        if (dependentAssetKeys[`${idx}`]) {
            dependentAssetKeys[`${idx}`].keys.push(`dependentAsset${++dependentAssetKeys[`${idx}`].id}`);
        } else {
            dependentAssetKeys[`${idx}`] = {
                id: 0,
                keys: ['dAsset0'],
            }
        }
        this.setState({ dependentAssetKeys, openModal: true });
    };

    mergeUniqueOptions = (baseOptions = [], createdOptions = []) => {
        const merged = [...(baseOptions || [])];
        (createdOptions || []).forEach((created) => {
            if (!created || !created._id) {
                return;
            }
            const exists = merged.find((item) => `${item && item._id}` === `${created._id}`);
            if (!exists) {
                merged.push(created);
            }
        });
        return merged;
    };

    getVendorOptions = () => {
        const { filters } = this.props;
        const baseOptions = filters && filters.vendor && filters.vendor.data && filters.vendor.data.data || [];
        return this.mergeUniqueOptions(baseOptions, this.state.createdVendors);
    };

    handleVendorCreated = (createdVendor) => {
        if (!createdVendor || !createdVendor._id) {
            return;
        }
        this.setState((prevState) => {
            const exists = (prevState.createdVendors || []).find((item) => `${item._id}` === `${createdVendor._id}`);
            if (exists) {
                return null;
            }
            return {
                createdVendors: [...(prevState.createdVendors || []), createdVendor],
            };
        });
        this.props.form.setFieldsValue({
            vendor: createdVendor._id,
        });
    };

    getOwnerOptions = () => {
        const { filters } = this.props;
        const baseOptions = filters && filters.owner && filters.owner.data && filters.owner.data.data || [];
        return this.mergeUniqueOptions(baseOptions, this.state.createdOwners);
    };

    handleOwnerCreated = (createdOwner) => {
        if (!createdOwner || !createdOwner._id) {
            return;
        }
        this.setState((prevState) => {
            const exists = (prevState.createdOwners || []).find((item) => `${item._id}` === `${createdOwner._id}`);
            if (exists) {
                return null;
            }
            return {
                createdOwners: [...(prevState.createdOwners || []), createdOwner],
            };
        });
        this.props.form.setFieldsValue({
            owner: createdOwner._id,
        });
    };

    normalizeRelationValue = (value) => {
        if (!value) {
            return value;
        }
        if (typeof value === 'string' || typeof value === 'number') {
            return value;
        }
        if (typeof value === 'object') {
            return value._id || value.id || '';
        }
        return value;
    };

    normalizeAssetDataRelations = (assetData) => {
        if (!assetData || typeof assetData !== 'object') {
            return;
        }
        ['equipmentSubType', 'assetModel'].forEach((field) => {
            if (Object.prototype.hasOwnProperty.call(assetData, field)) {
                assetData[field] = this.normalizeRelationValue(assetData[field]);
            }
        });
    };

    handleSubmit = (e) => {
        const { match, data } = this.props;
        const spareParts = data.spareParts;
        e.preventDefault();

        this.props.form.validateFields(async (err, values) => {
            if (err) {
                return console.log(err);
            }
            const { documentData } = this.state;
            values.documents = documentData;

            // if values.invoiceDate or values.grnDate is vailable, change the date to start of the day only

            if (values.invoiceDate) {
                values.invoiceDate = moment(values.invoiceDate).startOf('day').toDate();
            }
            if (values.grnDate) {
                values.grnDate = moment(values.grnDate).startOf('day').toDate();
            }

            console.log('values', JSON.stringify(values, null, 2));

            for (let i = 0; i < this.state.purchaseOrderData.assets.length; i++) {
                let asset = this.state.purchaseOrderData.assets[i];
                asset.dependent = [];
                for (let j = 0; j < this.state.purchaseOrderData.dependentAssets.length; j++) {
                    let dAsset = this.state.purchaseOrderData.dependentAssets[j];
                    if (i === dAsset.index) {
                        asset.dependent.push(dAsset);
                    }
                }
            }

            await this.state.purchaseOrderData.assets.map((item) => {
                values.assets[item.index].assetData = item.data;
                values.assets[item.index].dependent = item.dependent;
            });

            // Attach sub assets (rate-only entries) to their parent asset row so the
            // backend can create each sub asset + its Stock -> Asset transfer.
            Object.keys(this.state.subAssets || {}).forEach((idx) => {
                if (values.assets && values.assets[idx]) {
                    values.assets[idx].subAssets = this.state.subAssets[idx] || [];
                }
            });

            // await this.state.purchaseOrderData.dependentAssets.map((item) => {
            //   item.data.index = item.index;
            //   item.data.innerIndex = item.innerIndex;
            //   values.assets[item.index].dependentAssetData.push(item.data);
            // });

            values && values.assets && values.assets.forEach((item) => {
                if (item && item.assetData) {
                    this.normalizeAssetDataRelations(item.assetData);
                }
                if (item && item.subAssets && item.subAssets.length) {
                    // Keep only complete sub assets (an asset must have been picked) and
                    // normalize their relation fields exactly like the parent assetData.
                    item.subAssets = item.subAssets.filter((sub) => sub && sub.assetData);
                    item.subAssets.forEach((sub) => {
                        this.normalizeAssetDataRelations(sub.assetData);
                    });
                }
            });

            // await this.state.purchaseOrderData.spareParts.map((item) => {
            //   values.spareParts[item.index].sparePartData = item.data;
            // });

            // values && values.assets && await Promise.all(values.assets.map(async (item, index) => {
            //   item && item.dependent && item.dependent[index] && item.dependent[index]['data'] && await Object.keys(item.dependent[index].data).map(itm => {
            //     if (itm === 'equipmentSubType' || itm === 'assetModel') {
            //       item.dependent[index].data[itm] = item.dependent[index]['data'][itm]._id
            //     }
            //   });
            // }));

            if (values.type !== 'Spare') {
                for (let i = 0; i < values.assets.length; i++) {
                    let asset = values.assets[i];
                    for (let j = 0; j < asset.dependent.length; j++) {
                        let dAsset = asset.dependent[j];
                        this.normalizeAssetDataRelations(dAsset.data);
                    }
                }
            }

            if (match.params && match.params.id) {
                // if (values && values.spareParts && spareParts && spareParts.length) values.spareParts = values.spareParts.concat(spareParts);
                this.props.onSubmit(values, match.params.id);
            } else {
                this.props.onSubmit(values);
            }
        });
    };

    changeView = (type) => {
        if (this.state.type !== type) {
            this.id = 0;
            this.spareId = 0;
            this.setState({
                keys: [],
                spareKeys: [],
                purchaseOrderData: { assets: [], spareParts: [], dependentAssets: [] },
                subAssets: {},
            });
            this.setState({ type: type }, () => {
                if (type === 'Asset') {
                    this.props.fetchSubElementFilter('Asset');
                    this.addAsset();
                } else if (type === 'Spare') {
                    this.props.fetchSubElementFilter('SparePart');
                    this.props.getAllUOM();
                    this.addSpareParts();
                }
            })
        }
    };

    getAssetData(index, data) {
        if (data && data.length) {
            const { purchaseOrderData, intervalKeys } = this.state;
            const { form, filters, searchData } = this.props;

            let { assets } = purchaseOrderData;
            let assetUpdated = true;
            const kk = assets && assets.map(item => {
                if (item.index === index) {
                    assetUpdated = false;
                    item['data'] = { ...item['data'], ...data[0] };
                }
                return item;
            });

            purchaseOrderData['assets'] = kk;
            if (assetUpdated) {
                purchaseOrderData.assets.push({ index: index, data: data[0] });
            }

            this.setState({
                purchaseOrderData: purchaseOrderData,
            }, () => {
                if (data.length) {
                    this.props.form.setFields({
                        [`assets[${index}]['asset']`]: {
                            value: data.assetId || 1,
                            errors: [],
                        }
                    })
                } else {
                    this.props.form.setFields({
                        [`assets[${index}]['asset']`]: {
                            value: '',
                            errors: [new Error],
                        }
                    })
                }
            })
        }
    }

    getDependentAssetData(index, innerIndex, data) {
        if (data && data.length) {
            const { purchaseOrderData } = this.state;
            let { dependentAssets } = purchaseOrderData;
            let assetUpdated = true;
            const gg = dependentAssets && dependentAssets.map(item => {
                if (item.innerIndex === innerIndex && item.index === index) {
                    assetUpdated = false;
                    item['data'] = { ...item['data'], ...data[0] };
                }
                return item;
            });

            if (assetUpdated) {
                purchaseOrderData.dependentAssets.push({ index: index, innerIndex: innerIndex, data: data[0] });
            }

            this.setState({
                purchaseOrderData: purchaseOrderData,
            });
        }
    }

    removeStateAsset = (index) => {
        let { purchaseOrderData, intervalKeys, parentIntervalKeys } = this.state;
        const { assets } = purchaseOrderData;
        const newAsset = assets && assets.map(item => {
            if (item.index === index) {
                return {
                    index: item.index,
                    data: [item.data.assetId],
                }
            }
            return item;
        });
        delete intervalKeys[index];
        delete parentIntervalKeys[index];
        purchaseOrderData.assets = newAsset;
        this.setState({ purchaseOrderData, intervalKeys, parentIntervalKeys, parentPresent: [] });
    };

    removeStateDependentAsset = (index, innerIndex) => {
        let { purchaseOrderData, dependentAssetKeys } = this.state;
        const { dependentAssets } = purchaseOrderData;
        const newAsset = dependentAssets && dependentAssets.map(item => {
            if (item.innerIndex === innerIndex && item.index === index) {
                return {
                    index: item.index,
                    innerIndex: item.innerIndex,
                    data: [item.data.assetId],
                }
            }
            return item;
        });
        purchaseOrderData.dependentAssets = newAsset;
        this.setState({ purchaseOrderData, dependentAssetKeys, parentPresent: [] });
    };

    getSparePartData(index, data) {
        const { purchaseOrderData } = this.state;
        purchaseOrderData.spareParts.push({ index: index, data: data[0] });
        this.setState({
            purchaseOrderData: purchaseOrderData,
        })
    }

    getDocumentData = (data) => {
        this.setState({ documentData: data });
    };

    getLinkedAssetData = (data, index) => {
        parentPresent[index] = data;
        this.setState({ parentPresent: parentPresent });
    }

    onSpareSelect = (index, spareNameId) => {
        const { searchData, form } = this.props;
        const spareName = searchData && searchData.filter(item => JSON.stringify(item._id) === JSON.stringify(spareNameId));
        form.setFieldsValue({
            [`spareParts[${index}]['unitOfMeasurement']`]: spareName && spareName.length && spareName[0].unitOfMeasurement._id,
        })
    }

    handleInvoiceDateChange = (date) => {
        const { form, title, data } = this.props
        const type = form.getFieldValue('type')

        if (type === 'Spare' && date) {
            // In edit mode, don't overwrite existing MGRN date
            // In create mode, set MGRN date to invoice date by default
            const existingGrnDate = title === 'EDIT' && data && data.grnDate
            if (!existingGrnDate) {
                // If invoice date is provided, set MGRN date to invoice date by default
                // User can change it afterwards if needed
                form.setFieldsValue({
                    grnDate: date
                })
            }
        }

        // Re-validate invoice number and MGRN number when invoice date changes
        setTimeout(() => {
            form.validateFields(['invoiceNumber', 'grnNo'], { force: true })
        }, 100)
    }

    // Read-only list of the sub assets that were created against this PI, shown on
    // View/Edit so all assets created against the PI are visible in one place.
    existingSubAssetItems(index) {
        const { data } = this.props;
        const subAssets = data && data.assets && data.assets[index] && data.assets[index].subAssets;
        if (!subAssets || !subAssets.length) {
            return null;
        }
        const cardStyle = {
            marginTop: '10px',
            border: '1px dashed #52c41a',
            padding: '15px',
            borderRadius: '9px',
        };
        return <div style={{ marginTop: '10px' }}>
            <div>Sub Assets</div>
            {subAssets.map((sub, sIndex) => {
                const asset = (sub && sub.asset) || {};
                const subTypeName = asset.equipmentSubType && asset.equipmentSubType.name;
                const modelName = asset.assetModel && asset.assetModel.name;
                const ownerName = asset.owner && asset.owner.name;
                return <div key={sIndex} style={cardStyle}>
                    {asset.assetCode && <div>Asset Code: {asset.assetCode}</div>}
                    {subTypeName && <div>Asset Sub Type: {subTypeName}</div>}
                    {modelName && <div>Asset Model: {modelName}</div>}
                    {ownerName && <div>Owner: {ownerName}</div>}
                    <div>Rate: {(sub && sub.rate) || 0}</div>
                </div>
            })}
        </div>
    }

    assetFormItems() {
        const { data, form, filters, title, resource } = this.props;
        const { getFieldDecorator } = form;
        const { keys } = this.state;
        const style = {
            marginTop: '10px',
            border: '1px dashed #000',
            padding: '20px',
            borderRadius: '9px',
        };
        return keys.map((k, index) => {
            const { intervalKeys, purchaseOrderData, parentIntervalKeys, dependentAssetKeys } = this.state;

            const isExistingAsset = title === 'EDIT' && data && data.assets && data.assets[index];

            const parentAssetFormItems = parentIntervalKeys && parentIntervalKeys[`${index}`] && parentIntervalKeys[`${index}`]['keys'] && parentIntervalKeys[`${index}`]['keys'].map((k, pIndex) => {
                const value = data.assets &&
                    data.assets[index] &&
                    data.assets[index].parentService &&
                    data.assets[index].parentService[pIndex] &&
                    data.assets[index].parentService[pIndex];

                return <div key={pIndex} style={style}>Parent Asset Readings
                    <Form.Item key={`${index}3`} label={'Meter'} style={{ marginTop: '10px' }}>
                        {getFieldDecorator(`assets[${index}]['parentService'][${pIndex}]['parentInterval']`, {
                            rules: [{ required: true, message: `Parent Interval is required!` }],
                            initialValue: (value && value.parentInterval) || '',
                        })(<Input type='number'
                            onWheel={event => event.currentTarget.blur()}
                            placeholder={'Meter'}
                            style={{ marginRight: 8 }} />)
                        }
                    </Form.Item>

                    <Form.Item key={`${index}2`} label={'Meter Unit'}>
                        {getFieldDecorator(`assets[${index}]['parentService'][${pIndex}]['parentUnit']`, {
                            rules: [{ required: true, message: `Meter Unit is required!` }],
                            initialValue: (value && value.parentUnit) || '',
                        })(<Select
                            showSearch
                            allowClear
                            mode="single"
                            style={{ width: '80%' }}
                            placeholder={`Please Select Meter Unit`}
                            filterOption={(input, option) =>
                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                            }
                        >
                            {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['service']['schema']['unit'].data.data.map(item =>
                                <Select.Option key={item._id}
                                    value={item._id}>{item.name}</Select.Option>)}
                        </Select>)
                        }
                        {
                            filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['service']['schema']['unit'].options.master ?
                                <MasterModal resource={resource}
                                    item={filters['assets']['schema']['service']['schema']['unit'].options.ref}
                                    title={'CREATE'} /> : ''
                        }
                    </Form.Item>

                    {pIndex >= 0 ? (
                        <Icon
                            className="dynamic-delete-button"
                            type="minus-circle-o"
                            onClick={() => this.removeParentInterval(index, pIndex)}
                        />
                    ) : null}
                </div>
            });

            const formItems = intervalKeys && intervalKeys[`${index}`] && intervalKeys[`${index}`]['keys'] && intervalKeys[`${index}`]['keys'].map((k, fIndex) => {
                const value = data.assets &&
                    data.assets[index] &&
                    data.assets[index].service &&
                    data.assets[index].service[fIndex] &&
                    data.assets[index].service[fIndex];

                return <div key={fIndex} style={style}>

                    <Form.Item key={`${index}3`} label={'Meter'}>
                        {getFieldDecorator(`assets[${index}]['service'][${fIndex}]['interval']`, {
                            rules: [{ required: true, message: `Meter is required!` }],
                            initialValue: (value && value.interval) || '',
                        })(<Input type='number'
                            onWheel={event => event.currentTarget.blur()}
                            placeholder={'Meter'} style={{ marginRight: 8 }} />)
                        }
                    </Form.Item>
                    <Form.Item key={`${index}2`} label={'Meter Unit'}>
                        {getFieldDecorator(`assets[${index}]['service'][${fIndex}]['unit']`, {
                            rules: [{ required: true, message: `Meter Unit is required!` }],
                            initialValue: (value && value.unit) || '',
                        })(<Select
                            showSearch
                            allowClear
                            mode="single"
                            placeholder={`Please Select Meter Unit`}
                            filterOption={(input, option) =>
                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                            }
                        >
                            {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['service']['schema']['unit'].data.data.map(item =>
                                <Select.Option key={item._id}
                                    value={item._id}>{item.name}</Select.Option>)}
                        </Select>)
                        }
                    </Form.Item>

                    {fIndex >= 0 ? (
                        <Icon
                            className="dynamic-delete-button"
                            type="minus-circle-o"
                            onClick={() => this.removeInterval(index, fIndex)}
                        />
                    ) : null}
                </div>
            });
            const dependentAssetFormItems = dependentAssetKeys && dependentAssetKeys[`${index}`] && dependentAssetKeys[`${index}`]['keys'] &&
                dependentAssetKeys[`${index}`]['keys'].map((k, fIndex) => {
                    const value = data.assets &&
                        data.assets[index] &&
                        data.assets[index].dependentAsset &&
                        data.assets[index].dependentAsset[fIndex] &&
                        data.assets[index].dependentAsset[fIndex];
                    let dAsset = [];

                    let owner = this.state.parentOwner;

                    if (this.props.title !== 'CREATE') {
                        for (let k = 0; k < purchaseOrderData['assets'].length; k++) {
                            dAsset.push([]);
                        }

                        for (let i = 0; i < purchaseOrderData.dependentAssets.length; i++) {
                            let item = purchaseOrderData.dependentAssets[i];
                            if (index === item.index) {
                                dAsset[index].push(item.data);
                            }
                        }
                    }

                    return <div key={fIndex} style={style}>
                        <Form.Item key={`${index}3`}>
                            {getFieldDecorator(`assets[${index}]['dependentAsset'][${fIndex}]['asset']`, {})(<AssetModal
                                history={this.props.history} index={index} getLinkedAssetData={this.getLinkedAssetData}
                                title={this.props.title} dependentAsset={true} innerIndex={fIndex} owner={owner[index]}
                                match={this.props.match} key={'dependentAssets'} item={filters['assets']}
                                useAssetModelInlineCreate={true}
                                removeStateDependentAsset={this.removeStateDependentAsset} form={form}
                                data={(dAsset[index] && dAsset[index][fIndex] && [dAsset[index][fIndex]]) || []}
                                openModal={this.state.openModal}
                                getDependentAssetData={this.getDependentAssetData.bind(this, index, fIndex)} />)
                            }
                        </Form.Item>

                        {fIndex >= 0 ? (
                            <Icon
                                className="dynamic-delete-button"
                                type="minus-circle-o"
                                onClick={() => this.removeDependentAsset(index, fIndex)}
                            />
                        ) : null}
                    </div>
                });
            return <div key={index} style={style}>
                <AssetModal history={this.props.history}
                    index={index}
                    getLinkedAssetData={this.getLinkedAssetData}
                    title={this.props.title}
                    match={this.props.match}
                    key={'assets'}
                    item={filters['assets']}
                    useAssetModelInlineCreate={true}
                    removeStateAsset={this.removeStateAsset}
                    form={form}
                    owner={form.getFieldValue('owner')}
                    saveOwner={this.saveOwner.bind(this, index)}
                    data={(purchaseOrderData['assets'] && purchaseOrderData['assets'][index] && purchaseOrderData['assets'][index].data && purchaseOrderData['assets'][index].data && [purchaseOrderData['assets'][index].data]) || []}
                    getAssetData={this.getAssetData.bind(this, index)} />
                <Form.Item key={`${index}0`}>
                    {getFieldDecorator(`assets[${index}]['asset']`, {
                        rules: [{ required: true, message: `Asset is required!` }],
                        initialValue: data.assets && data.assets[index] && data.assets[index].asset && data.assets[index].asset._id || '',
                    })(<Input type='number' placeholder={'asset'} style={{ marginRight: 8, display: 'none' }} />)
                    }
                </Form.Item>
                <Form.Item key={`${index}1`} label={'Location'}>
                    {getFieldDecorator(`assets[${index}]['location']`, {
                        rules: [{ required: true, message: `Location is required!` }],
                        initialValue: data.assets && data.assets[index] && data.assets[index].location && data.assets[index].location._id || '',
                    })(<Select
                        // disabled={title === 'EDIT' || title === 'VIEW'}
                        disabled={isExistingAsset}
                        showSearch
                        mode="single"
                        style={{ width: '80%' }}
                        placeholder={`Please Select Location`}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                    >
                        {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['location'].data.data.map(item => !item.isSystemGenerated &&
                            <Select.Option key={item._id}
                                value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                    {
                        filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['location'].options.master ?
                            <MasterModal resource={resource} item={filters['assets']['schema']['location'].options.ref}
                                title={'CREATE'} /> : ''
                    }
                </Form.Item>

                <Form.Item key={`${index}2`} label={'Sub Location'}>
                    {getFieldDecorator(`assets[${index}]['client']`, {
                        rules: [{ required: false, message: `Sub Location is required!` }],
                        initialValue: data.assets && data.assets[index] && data.assets[index].client && data.assets[index].client._id || '',
                    })(<Select
                        // disabled={title === 'EDIT' || title === 'VIEW'}
                        disabled={isExistingAsset}
                        showSearch
                        allowClear
                        mode="single"
                        style={{ width: '80%' }}
                        placeholder={`Please Select Sub Location`}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                    >
                        {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['client'].data.data.map(item => !item.isSystemGenerated &&
                            <Select.Option key={item._id}
                                value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                    {
                        filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['client'].options.master ?
                            <MasterModal resource={resource} item={filters['assets']['schema']['client'].options.ref}
                                title={'CREATE'} /> : ''
                    }
                </Form.Item>

                <Form.Item key={`${index}3`} label={'Rate'}>
                    {getFieldDecorator(`assets[${index}]['rate']`, {
                        rules: [{ required: true, message: `Rate is required!` }],
                        initialValue: data.assets && data.assets[index] && data.assets[index]['rate'] || 0,
                    })(<Input type='number'
                        onWheel={event => event.currentTarget.blur()}
                        placeholder={'Rate'}
                        style={{ marginRight: 8 }} />)
                    }
                </Form.Item>

                <Form.Item key={`${index}4`} label={'Quantity'}>
                    {getFieldDecorator(`assets[${index}]['astQty']`, {
                        rules: [{ required: true, message: `Quantity is required!` }],
                        initialValue: data.assets && data.assets[index] && data.assets[index]['astQty'] || 1,
                    })(<InputNumber
                        // disabled={title === 'EDIT' || title === 'VIEW'}
                        disabled={isExistingAsset}
                        onWheel={event => event.currentTarget.blur()}
                        min={1} max={100}
                        placeholder={'Quantity'}
                        style={{ marginRight: 8 }} />)
                    }
                </Form.Item>

                {
                    (title !== 'EDIT' && title !== 'VIEW') && <div style={{ marginTop: '10px' }}>
                        <div>Sub Assets</div>
                        <SubAssetModal
                            index={index}
                            value={this.state.subAssets[index] || []}
                            onChange={this.setSubAssets}
                            item={filters['assets']}
                            form={form}
                            title={title}
                            history={this.props.history}
                            match={this.props.match}
                            owner={form.getFieldValue('owner')}
                            useAssetModelInlineCreate={true}
                            disabled={title === 'VIEW'}
                        />
                    </div>
                }

                {
                    (title === 'EDIT' || title === 'VIEW') && this.existingSubAssetItems(index)
                }

                {formItems}

                <Form.Item>
                    <Button type="dashed" onClick={this.addInterval.bind(this, index)}
                        style={{ width: '60%', marginTop: '15px' }}>
                        <Icon type="plus" /> Add Asset Reading
                    </Button>
                </Form.Item>

                {parentAssetFormItems}

                {
                    this.state.parentPresent[index] ?
                        <Form.Item>
                            <Button type="dashed" onClick={this.addParentInterval.bind(this, index)}
                                style={{ width: '60%', marginTop: '15px' }}>
                                <Icon type="plus" /> Add Parent Asset Reading
                            </Button>
                        </Form.Item> : ''
                }

                {/* TODO: Dependent Asset is not required for now (will use SAT)*/}
                {/* {dependentAssetFormItems}
                <Form.Item>
                    <Button type="dashed" onClick={this.addDependentAsset.bind(this, index)}
                        style={{ width: '60%', marginTop: '15px' }}>
                        <Icon type="plus" /> Add Dependent Asset
                    </Button>
                </Form.Item> */}

                {(index > 0 && title !== 'EDIT') ? (
                    <Icon
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        onClick={() => this.removeAsset(index)}
                    />
                ) : null}
            </div>
        });
    }

    sparePartFormItems() {
        const { data, form, filters, resource, title, uomData } = this.props;
        const { getFieldDecorator, setFieldsValue } = form;
        const { spareKeys } = this.state;
        const style = {
            marginTop: '10px',
            border: '1px dashed #000',
            padding: '20px',
            borderRadius: '9px',
        };
        return spareKeys.map((k, index) => (
            <div key={index} style={style}>

                <FieldSearchForm
                    title={title}
                    otherDetails={{ title, resource, setFieldsValue }}
                    options={filters && filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['type'].options}
                    key={'Type'}
                    name={`spareParts[${index}]['type']`}
                    label={'Type'}
                    message={`Type is required`}
                    required={true}
                    onSelect={this.onSpareSelect.bind(this, index)}
                    disabled={(title === 'EDIT' && filters && filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['type'].options.disabledOnEdit) || false}
                    field={filters && filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['type'].options.main}
                    model={filters && filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['type'].options.ref}
                    initialValue={null}
                    getFieldDecorator={getFieldDecorator}
                    setFieldsValue={setFieldsValue}
                />

                <Form.Item key={`${index}6`} label={'Unit of measurement'}>
                    {
                        getFieldDecorator(`spareParts[${index}]['unitOfMeasurement']`, {
                            rules: [{ required: false, message: `Unit Of Measurement is required!` }],
                            initialValue: '',
                        })(<Select
                            showSearch
                            allowClear
                            mode="single"
                            style={{ width: '80%' }}
                            placeholder="Please Unit Of Measurement"
                            disabled
                            filterOption={(input, option) =>
                                (option.props.children + "").toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {uomData && uomData.map(item =>
                                <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                        </Select>)
                    }
                    {/*{*/}
                    {/*filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['unitOfMeasurement'].options.master ?*/}
                    {/*<MasterModal resource={resource} item={filters['spareParts']['schema']['unitOfMeasurement'].options.ref}*/}
                    {/*title={'CREATE'}/> : ''*/}
                    {/*}*/}
                </Form.Item>

                <Form.Item key={`${index}2`} label={'Rate'}>
                    {getFieldDecorator(`spareParts[${index}]['rate']`, {
                        rules: [{ required: true, message: `Rate is required!` }],
                        initialValue: '',
                    })(<Input type='number'
                        placeholder={'Rate'}
                        onWheel={event => event.currentTarget.blur()}
                        style={{ marginRight: 8 }} />
                    )
                    }
                </Form.Item>

                <Form.Item key={`${index}3`} label={'Quantity'}>
                    {getFieldDecorator(`spareParts[${index}]['quantity']`, {
                        rules: [{ required: true, message: `Quantity is required!` }],
                        initialValue: '',
                    })(<Input type='number'
                        onWheel={event => event.currentTarget.blur()}
                        placeholder={'Quantity'}
                        style={{ marginRight: 8 }} />
                    )
                    }
                </Form.Item>

                <Form.Item key={`${index}4`} label={'Location'}>
                    {getFieldDecorator(`spareParts[${index}]['location']`, {
                        rules: [{ required: true, message: `Location is required!` }],
                        initialValue: '',
                    })(<Select
                        showSearch
                        mode="single"
                        style={{ width: '80%' }}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        placeholder={`Please Select Location`}
                    >
                        {filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['location'].data.data.map(item => !item.isSystemGenerated &&
                            <Select.Option key={item._id}
                                value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                    {
                        filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['location'].options.master ?
                            <MasterModal resource={resource}
                                item={filters['spareParts']['schema']['location'].options.ref}
                                title={'CREATE'} /> : ''
                    }
                </Form.Item>

                <Form.Item key={`${index}5`} label={'Sub Location'}>
                    {getFieldDecorator(`spareParts[${index}]['client']`, {
                        rules: [{ required: false, message: `Sub Location is required!` }],
                        initialValue: '',
                    })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        style={{ width: '80%' }}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        placeholder={`Please Select Sub Location`}
                    >
                        {filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['client'].data.data.map(item => !item.isSystemGenerated &&
                            <Select.Option key={item._id}
                                value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                    {
                        filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['client'].options.master ?
                            <MasterModal resource={resource}
                                item={filters['spareParts']['schema']['client'].options.ref}
                                title={'CREATE'} /> : ''
                    }
                </Form.Item>

                {
                    this.getTotalAmount(index)
                }

                {index > 0 ? (
                    <Icon
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        onClick={() => this.removeSpareParts(index)}
                    />
                ) : null}
            </div>
        ));
    }

    cancelDelete = () => {
        message.error('Cancelled')
    };

    deleteSpareInPurchaseInvoice = (id) => {
        this.props.deleteSpareInPurchaseInvoice(id, this.state.purchaseOrderID);
    }

    getTotalAmount(index) {
        const { form } = this.props;
        const val = form.getFieldValue('spareParts');
        let total = (val[index].quantity) * (+val[index].rate);
        return <Descriptions bordered title="">
            <Descriptions.Item label="Total amount">
                {
                    total && total.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                    })
                }
            </Descriptions.Item>
        </Descriptions>
    }

    sparePartTable() {
        const { data, title, history } = this.props;
        const sparePartDataSource = [];
        const sparePartColumns = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Location',
                dataIndex: 'location',
                key: 'location',
            },
            {
                title: 'Sub Location',
                dataIndex: 'client',
                key: 'client',
            },
            {
                title: 'Rate',
                dataIndex: 'rate',
                key: 'rate',
            },
            {
                title: 'Quantity',
                dataIndex: 'quantity',
                key: 'quantity',
            },
            {
                title: 'Unit Of Measurement',
                dataIndex: 'unitOfMeasurement',
                key: 'unitOfMeasurement',
            },
            {
                title: 'Total amount',
                dataIndex: 'total',
                key: 'total',
            },

            // {
            //   title: 'Edit',
            //   dataIndex: 'edit',
            //   key: 'edit',
            //   render: (id) => {
            //       return <AccessControl resource={'SparePartTransaction'} permissionNeeded={'u'}
            //                             roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            //       return <Button type='info' onClick={() => history.push(`/spare-part-transaction/edit/${id}`)}>Edit</Button>
            //     }}/>
            //   }
            // },
            // {
            //   title: 'Delete',
            //   dataIndex: 'edit',
            //   key: 'edit',
            //   render: (id) => {
            //     return <AccessControl resource={'SparePartTransaction'} permissionNeeded={'u'}
            //                           roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            //       return <Popconfirm
            //         title="Are you sure you want to delete this Spare record From Purchase invoice?"
            //         onConfirm={() => {
            //           this.deleteSpareInPurchaseInvoice(id)
            //         }}
            //         onCancel={this.cancelDelete}
            //         okText="Yes"
            //         cancelText="No"
            //       >
            //         <Button style={{marginLeft: '10px'}} type="danger" size='small'>Delete</Button>
            //       </Popconfirm>
            //     }}/>
            //   }
            // },

            {
                title: 'Action',
                key: 'edit',
                dataIndex: 'edit',
                render: (id, record) => (
                    <div>
                        {/* <AccessControl resource={'SparePartTransaction'} permissionNeeded={'u'}
                            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                                return <Button type='info'
                                    disabled={title === 'VIEW'}
                                    onClick={() => history.push(`/spare-part-transaction/edit/${id}/${data._id}`)}>Edit</Button>
                            }} /> */}

                        <AccessControl resource={'SparePartTransaction'} permissionNeeded={'d'}
                            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                                return title !== 'VIEW' && <Popconfirm
                                    title="Are you sure you want to delete this Spare record From Purchase invoice?"
                                    onConfirm={() => {
                                        this.deleteSpareInPurchaseInvoice(record.delete)
                                    }}
                                    onCancel={this.cancelDelete}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button style={{ marginLeft: '10px' }}
                                        type="danger"
                                        disabled={title === 'VIEW'}
                                    >Delete</Button>
                                </Popconfirm>
                            }} />

                    </div>
                ),
            }
        ];

        let sparePartTableData = title === 'EDIT' || "VIEW" ? ((data && data.spareParts) || []) : [];
        sparePartTableData.map((item, index) => {
            const spareId = (item && item.sparePartTransaction && item.sparePartTransaction.type && item.sparePartTransaction.type._id) || '';
            const name = (item && item.sparePartTransaction && item.sparePartTransaction.type && item.sparePartTransaction.type.name) || '';
            const qty = (item && item.sparePartTransaction && item.sparePartTransaction.quantity) || 0;
            const rate = (item && item.sparePartTransaction && item.sparePartTransaction.rate) || 0;
            const client = (item && item.client) || {};
            const loc = (item && item.location) || {};
            sparePartDataSource.push({
                key: index,
                name: item.type._id.toString() === spareId.toString() ? name : '-',
                rate: rate.toLocaleString('en-IN', {
                    maximumFractionDigits: 2,
                    style: 'currency',
                    currency: 'INR'
                }) || 0,
                quantity: qty,
                unitOfMeasurement: (item && item.sparePartTransaction && item.sparePartTransaction.type && item.sparePartTransaction.type.unitOfMeasurement && item.sparePartTransaction.type.unitOfMeasurement.name) || '',
                client: item.sparePartTransaction && item.sparePartTransaction.client === client._id ? client.name : '',
                total: (qty && rate) && (qty * rate).toLocaleString('en-IN', {
                    maximumFractionDigits: 2,
                    style: 'currency',
                    currency: 'INR'
                }),
                location: item.sparePartTransaction && item.sparePartTransaction.location === loc._id ? loc.name : '',
                edit: item.sparePartTransaction && item.sparePartTransaction._id,
                delete: (item.type && item.type._id) || null,
            })
        });
        return <Table columns={sparePartColumns} dataSource={sparePartDataSource} pagination={false} />
    }

    totalAmount() {
        const { data, title, history } = this.props;
        let totalAmount = 0;
        let sparePartTableData = title === 'EDIT' ? ((data && data.spareParts) || []) : [];
        sparePartTableData.map(item => {
            totalAmount = totalAmount + (item.quantity * item.rate);
        });
        return <Descriptions bordered title="">
            <Descriptions.Item label="Total amount">
                {
                    totalAmount && totalAmount.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                    })
                }
            </Descriptions.Item>

        </Descriptions>
    }

    totalPurchaseAmount() {
        const { form, data } = this.props;
        const state = this.state;

        let totalAmount = 0;

        let sparePart = form.getFieldValue('spareParts') || [];
        // console.log(sparePart);
        // console.log(sparePart instanceof Array);
        // console.log(Array.isArray(sparePart));
        if (!Array.isArray(sparePart)) {
            sparePart = [sparePart[0]];
        }
        // console.log(sparePart);
        // console.log(sparePart instanceof Array);
        // console.log(Array.isArray(sparePart));

        let assetPart = form.getFieldValue('assets') || [];

        if (state.type && state.type.toLowerCase() === 'asset')
            assetPart.map(item => {
                if (item.rate)
                    totalAmount = totalAmount + ((+item.rate) * (+item.astQty));
            });
        else {
            if (data && data.spareParts)
                sparePart = sparePart.concat(data.spareParts);
            sparePart.map(item => {
                totalAmount = totalAmount + ((+item.quantity) * (+item.rate));
            });
        }

        return <Descriptions bordered title="">
            <Descriptions.Item label="Total amount">
                {
                    totalAmount && totalAmount.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                    })
                }
            </Descriptions.Item>

        </Descriptions>
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { data, loading, filters, title, resource, form, searchData } = this.props;
        const vendorOptions = this.getVendorOptions();
        const ownerOptions = this.getOwnerOptions();
        const currentType = form.getFieldValue('type');
        const currentInvoiceDate = form.getFieldValue('invoiceDate');
        return (
            <Spin spinning={loading}>
                <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName('purchaseInvoice')}`}>
                    <Form onSubmit={this.handleSubmit} layout="vertical">

                        <Form.Item key={'type'} label={'Type'}>
                            {getFieldDecorator('type', {
                                rules: [{ required: true, message: `type is required!` }],
                                initialValue: data && data.type,
                            })(<Select
                                mode="single"
                                style={{ width: '100%' }}
                                placeholder="Please select"
                                onSelect={this.changeView}
                                disabled={this.props.title === 'EDIT'}
                            >
                                {filters['type'] && filters['type']['options'] && filters['type']['options'].enum && filters['type']['options'].enum.map((item, index) =>
                                    <Select.Option key={index}
                                        value={item}>{item}</Select.Option>)}
                            </Select>)
                            }
                        </Form.Item>

                        {
                            (title === 'EDIT') && <Form.Item key={'poNo'} label={'PI Number'}>
                                {getFieldDecorator('poNo', {
                                    rules: [{ required: false, message: `PO Number is required!` }],
                                    initialValue: ((data && data.poNo) || '')
                                })(<Input disabled />)
                                }
                            </Form.Item>
                        }

                        <Form.Item key={'invoiceDate'} label={'Invoice Date'} required={currentType !== 'Spare'}>
                            {getFieldDecorator('invoiceDate', {
                                rules: [{
                                    validator: (rule, value, callback) => {
                                        const type = form.getFieldValue('type')
                                        if (type !== 'Spare' && !value) {
                                            callback('Invoice Date is required!')
                                        } else {
                                            callback()
                                        }
                                    }
                                }],
                                initialValue: data && data.invoiceDate && moment(data.invoiceDate),
                            })(<DatePicker
                                onChange={this.handleInvoiceDateChange}
                                disabled={(title === 'EDIT' && filters['invoiceDate'] && filters['invoiceDate'].options.disabledOnEdit && data && data.invoiceDate) || false} />)
                            }
                        </Form.Item>

                        <Form.Item key={'invoiceNumber'} label={'Invoice Number'} required={currentType !== 'Spare' || !!currentInvoiceDate}>
                            {getFieldDecorator('invoiceNumber', {
                                rules: [{
                                    validator: (rule, value, callback) => {
                                        const type = form.getFieldValue('type')
                                        const invoiceDate = form.getFieldValue('invoiceDate')
                                        if (type !== 'Spare' && !value) {
                                            callback('Invoice Number is required!')
                                        } else if (type === 'Spare' && invoiceDate && !value) {
                                            callback('Invoice Number is required when Invoice Date is provided!')
                                        } else {
                                            callback()
                                        }
                                    }
                                }],
                                initialValue: data && data.invoiceNumber,
                            })(<Input
                                disabled={(title === 'EDIT' && filters['invoiceNumber'] && filters['invoiceNumber'].options.disabledOnEdit && data && data.invoiceNumber) || false} />)
                            }
                        </Form.Item>

                        <Form.Item key={'owner'} label={'Owner'} required={currentType === 'Asset'}>
                            {getFieldDecorator('owner', {
                                rules: [{
                                    validator: (rule, value, callback) => {
                                        const type = form.getFieldValue('type')
                                        if (type === 'Asset' && !value) {
                                            callback('Owner is required!')
                                        } else {
                                            callback()
                                        }
                                    }
                                }],
                                initialValue: data && data.owner && data.owner._id,
                            })(<Select
                                showSearch
                                allowClear
                                style={{ width: '80%' }}
                                placeholder="Please select"
                                filterOption={(input, option) =>
                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                }
                                disabled={(title === 'EDIT' && filters['owner'] && filters['owner'].options.disabledOnEdit) || false}
                            >
                                {(ownerOptions || []).map(item =>
                                    <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                            </Select>)}
                            {
                                filters['owner'] && filters['owner'].options && filters['owner'].options.master ?
                                    <InlineCreateMasterModal
                                        item={filters['owner'].options.ref}
                                        onCreated={this.handleOwnerCreated}
                                        triggerStyle={{
                                            margin: '0',
                                            marginTop: '0',
                                            marginLeft: '10px',
                                            width: 'calc(100% - 10px)'
                                        }}
                                    /> : ''
                            }
                        </Form.Item>

                        <Form.Item key={'vendor'} label={'Vendor'}>
                            {getFieldDecorator('vendor', {
                                rules: [{ required: true, message: `Vendor is required!` }],
                                initialValue: data && data.vendor && data.vendor._id,
                            })(<Select
                                showSearch
                                style={{ width: '80%' }}
                                placeholder="Please select"
                                filterOption={(input, option) =>
                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                }
                                disabled={(title === 'EDIT' && filters['vendor'] && filters['vendor'].options.disabledOnEdit) || false}
                            >
                                {(vendorOptions || []).map(item =>
                                    <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                            </Select>)}
                            {
                                filters['vendor'] && filters['vendor'].options && filters['vendor'].options.master ?
                                    <InlineCreateMasterModal
                                        item={filters['vendor'].options.ref}
                                        onCreated={this.handleVendorCreated}
                                        triggerStyle={{
                                            margin: '0',
                                            marginTop: '0',
                                            marginLeft: '10px',
                                            width: 'calc(100% - 10px)'
                                        }}
                                    /> : ''
                            }
                        </Form.Item>

                        <Form.Item key={'orderNumber'} label={'Order Number'}>
                            {getFieldDecorator('orderNumber', {
                                rules: [{ required: false, message: `Order Number is required!` }],
                                initialValue: data && data.orderNumber,
                            })(<Input
                                disabled={(title === 'EDIT' && filters['orderNumber'] && filters['orderNumber'].options.disabledOnEdit) || false} />)
                            }
                        </Form.Item>

                        <Form.Item key={'orderDate'} label={'Order Date'}>
                            {getFieldDecorator('orderDate', {
                                rules: [{ required: false, message: `Order Date is required!` }],
                                initialValue: data && data.orderDate && moment(data.orderDate),
                            })(<DatePicker
                                disabled={(title === 'EDIT' && filters['orderDate'] && filters['orderDate'].options.disabledOnEdit) || false} />)
                            }
                        </Form.Item>

                        <Form.Item key={'grnDate'} label={'MGRN Date'} required>
                            {getFieldDecorator('grnDate', {
                                rules: [{
                                    validator: (rule, value, callback) => {
                                        const type = form.getFieldValue('type')
                                        if (type === 'Spare' && !value) {
                                            callback('MGRN Date is required!')
                                        } else if (type !== 'Spare' && !value) {
                                            callback('MGRN Date is required!')
                                        } else {
                                            callback()
                                        }
                                    }
                                }],
                                initialValue: data && data.grnDate && moment(data.grnDate),
                            })(<DatePicker
                                disabled={(title === 'EDIT' && ((filters['grnDate'] && filters['grnDate'].options.disabledOnEdit) || (data && data.grnDate))) || false} />)
                            }
                        </Form.Item>

                        <Form.Item key={'grnNo'} label={'Manual GRN Number'} required={currentType === 'Spare' && !currentInvoiceDate}>
                            {getFieldDecorator('grnNo', {
                                rules: [{
                                    validator: (rule, value, callback) => {
                                        const type = form.getFieldValue('type')
                                        const invoiceDate = form.getFieldValue('invoiceDate')
                                        // If type is Spare and invoice date is NOT provided, MGRN number is required
                                        // If type is Spare and invoice date IS provided, MGRN number is optional
                                        if (type === 'Spare' && !invoiceDate && !value) {
                                            callback('Manual GRN Number is required when Invoice Date is not provided!')
                                        } else {
                                            callback()
                                        }
                                    }
                                }],
                                initialValue: data && data.grnNo,
                            })(<Input
                                disabled={(title === 'EDIT' && filters['grnNo'] && filters['grnNo'].options.disabledOnEdit) || false} />)
                            }
                        </Form.Item>

                        <DocumentList history={this.props.history}
                            match={this.props.match}
                            key={'documents'}
                            item={filters['documents']}
                            form={form} data={data['documents']}
                            getDocumentData={this.getDocumentData} />

                        {(data && data.spareParts && data.spareParts.length && this.sparePartTable()) || ''}
                        <br />

                        {
                            (
                                this.state.type === 'Asset' && <>
                                    <div>Assets</div>
                                    {this.assetFormItems()}
                                    {
                                        // title !== 'EDIT' ?
                                        <Button type="dashed" onClick={this.addAsset}
                                            style={{ width: '60%', marginTop: '15px' }}>
                                            <Icon type="plus" /> Add Asset
                                        </Button>
                                        // : ''
                                    }
                                </>
                            ) ||
                            (
                                this.state.type === 'Spare' && <>
                                    <div>Spare Part</div>
                                    {this.sparePartFormItems()}
                                    <Button type="dashed" onClick={this.addSpareParts}
                                        style={{ width: '60%', marginTop: '15px' }}>
                                        <Icon type="plus" /> Add Spare Parts
                                    </Button>
                                </>
                            )
                        }
                        {
                            this.totalPurchaseAmount()
                        }
                        <Form.Item>
                            <Button type="primary" hidden={this.props.title === 'VIEW'} className="gx-mb-0 gx-mt-2"
                                htmlType="submit"
                                loading={loading}>
                                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Spin>
        );
    }
}

const CreateForm = Form.create({
    name: 'global_state',
    onFieldsChange(props, changedFields) {
        props.onChange(changedFields);
    },
})(Create);

export default CreateForm;
